import { IconV1 } from 'common/icon/iconV1.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { getTableIconName, Rainfall } from '../headers/table-icons.js';
import { CellRenderType, ComponentTester } from './renderCell.js';

/** Type defined here to render data */

const getIcon = (_rainfall: number | string) => {
  const rainfall = Number(_rainfall);
  if (!isNaN(rainfall)) {
    if (rainfall >= 0 && rainfall < 0.2) {
      return getTableIconName(Rainfall.NONE);
    }
    if (rainfall >= 0.2 && rainfall < 2.1) {
      return getTableIconName(Rainfall.LIGHT);
    }
    if (rainfall >= 2.1 && rainfall < 6.1) {
      return getTableIconName(Rainfall.MODERATE);
    }
    if (rainfall >= 6.1 && rainfall < 25) {
      return getTableIconName(Rainfall.HEAVY);
    }
    if (rainfall >= 25 && rainfall <= Infinity) {
      return getTableIconName(Rainfall.TORRENTIAL);
    }
  }
  return undefined;
};

export const RenderRainfall: ComponentTester<CellRenderType.rainfall> = ({ data }) => {
  const rain = Number(data?.rainfall3Hour);
  const text = <small className="u-block u-textBold">{isNaN(rain) ? 'N/A' : rain}</small>;
  if (!data?.formatDisplay && data?.rainfallPerHour) {
    messageLog.info(`${data.rainfallPerHour}`, ['rain', isNaN(rain)]);
  }
  if (data?.formatDisplay) {
    const icon = getIcon(data.rainfallPerHour);
    if (icon) {
      return (
        <div className="render-rainfall">
          <div className="u-block u-mT-xs u-mB-xs IconWithText IconWithText--tight IconWithText--small IconWithText--vCenter">
            <div className="IconWithText-icon">{icon && <IconV1 icon={icon} />}</div>
            {text}
          </div>
        </div>
      );
    }
  }
  return text;
};
